import {Box, Flex, Image, Text} from '@chakra-ui/react'
import ListExam from '@pages/ExamPage/components/ListExam'
import Q12024Image from '@assets/images/exam/q1-2024.png'
import Q22024Image from '@assets/images/exam/q2-2024.png'

const Exam = ({data, index, type}: any) => {
  return (
    <Flex
      padding={{base: '16px', md: '40px'}}
      width={'100%'}
      backgroundColor={'#ffffff'}
      borderRadius={'24px'}
      flexDirection={{base: 'column', md: 'row'}}
      border={'1px solid var(--Neutral-100, #EFEFEF)'}>
      <Flex w={{base: '100%', md: '40%'}} flexDirection={'column'} gap={'20px'}>
        {data?.image && (
          <Image w={{base: '160px', md: '250px'}} src={data?.image} />
        )}

        {data?.is_updating && (
          <Flex
            alignItems={'center'}
            gap={'8px'}
            borderRadius={'100px'}
            bg={'rgba(0, 180, 28, 0.10)0'}
            p={'12px 20px'}
            w={'fit-content'}>
            <Box
              borderRadius={'50%'}
              h={'6px'}
              w={'6px'}
              backgroundColor={'#45BB66'}
            />
            <Text
              color={'#52C41A'}
              fontWeight={700}
              fontSize={{base: '12px', md: '16px'}}>
              Đang cập nhật
            </Text>
          </Flex>
        )}
      </Flex>
      <Flex flex={1}>
        <ListExam data={data?.tests} setName={data?.set_name} type={type} />
      </Flex>
    </Flex>
  )
}

export default Exam
